import React, { useEffect, useState } from "react";
import { Row, Col, ListGroup } from "react-bootstrap";
import "react-quill/dist/quill.snow.css";

// Shared renderer for one release: top panel with the release name +
// description, then a 1/3–2/3 split with the video list on the left and the
// player on the right. Used by both the first-login ReleaseNotesModal and the
// userprofile Release Notes section.
export default function ReleaseNotesViewer({ release }) {
  const [selectedIdx, setSelectedIdx] = useState(0);

  useEffect(() => {
    setSelectedIdx(0);
  }, [release?._id]);

  if (!release) return null;

  const videos = release.videos || [];
  const selected = videos[selectedIdx] || null;

  return (
    <div>
      {/* Top panel — release name + description */}
      <div
        className="border rounded p-3 mb-3"
        style={{ background: "rgba(207, 226, 255, 0.35)" }}
      >
        <div className="d-flex justify-content-between align-items-start flex-wrap gap-2">
          <h5 className="text-primary mb-1">{release.name}</h5>
          {release.releasedAt && (
            <span className="small text-muted">
              Released {new Date(release.releasedAt).toLocaleDateString("en-GB")}
            </span>
          )}
        </div>
        {release.descriptionHtml ? (
          <div
            className="ql-editor p-0"
            style={{ minHeight: 0 }}
            dangerouslySetInnerHTML={{ __html: release.descriptionHtml }}
          />
        ) : (
          <p className="mb-0 small text-muted">No description provided.</p>
        )}
      </div>

      {/* Videos — list (1/3) + player (2/3) */}
      {videos.length === 0 ? (
        <p className="mb-0">No videos for this release.</p>
      ) : (
        <Row>
          <Col xs={12} md={4} className="mb-2 mb-md-0">
            <h6 className="mb-2 text-primary fw-bold">Videos</h6>
            <ListGroup>
              {videos.map((video, idx) => (
                <ListGroup.Item
                  key={video.blobName || idx}
                  action
                  active={idx === selectedIdx}
                  onClick={() => setSelectedIdx(idx)}
                >
                  <i className="fa-solid fa-play me-2" />
                  {video.title}
                </ListGroup.Item>
              ))}
            </ListGroup>
          </Col>
          <Col xs={12} md={8}>
            {selected ? (
              <video
                key={selected.blobName || selected.url}
                controls
                preload="metadata"
                playsInline
                style={{ width: "100%", borderRadius: 8 }}
                src={selected.url}
              >
                Your browser does not support the video tag.
              </video>
            ) : (
              <p>Select a video to play.</p>
            )}
          </Col>
        </Row>
      )}
    </div>
  );
}
